var nn = Object.defineProperty;
var rn = (e, n, t) => n in e ? nn(e, n, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[n] = t;
var Ce = (e, n, t) => (rn(e, typeof n != "symbol" ? n + "" : n, t), t);
import on from "lodash";
var $ = /* @__PURE__ */ ((e) => (e.PATSNAP = "patsnap", e.OFFICIAL = "official", e))($ || {});
const _r = (e) => {
  if (e.resolution) {
    if (!e.pp_bbox)
      return {
        type: $.OFFICIAL
      };
    const n = e.resolution.split("x").map((c) => parseInt(`0${c}`, 10)), {
      x1: t,
      y1: r,
      x2: i,
      y2: o
    } = e.pp_bbox;
    return {
      model: {
        path: e.url || e.storage_path,
        oriWidth: n[0],
        oriHeight: n[1],
        box: [t, r, i, o]
      },
      type: $.PATSNAP
    };
  }
  return e.url ? {
    type: $.OFFICIAL,
    src: e.url,
    originSrc: e.originUrl
  } : {
    type: $.OFFICIAL
  };
}, gr = (e) => {
  if (!e)
    return {
      type: $.OFFICIAL
    };
  if (e.resolution) {
    if (!e.pp_bbox)
      return {
        type: $.PATSNAP
      };
    const n = e.resolution.split("x").map((c) => parseInt(`0${c}`, 10)), {
      x1: t,
      y1: r,
      x2: i,
      y2: o
    } = e.pp_bbox;
    return {
      model: {
        id: e.page_index,
        path: e.url || e.storage_path,
        oriWidth: n[0],
        oriHeight: n[1],
        box: [t, r, i, o]
      },
      type: $.PATSNAP
    };
  }
  return {
    type: $.OFFICIAL,
    src: e.storage_path,
    originSrc: e.storage_path,
    thumbSrc: e.fulltext_image240_url
  };
};
let dt = /* @__PURE__ */ new Map(), De = /* @__PURE__ */ new Map();
function wr(e, n) {
  dt.set(e, n);
}
function un(e) {
  return dt.get(e);
}
function Sr(e) {
  const n = De.get(e);
  return n ? un(n) : null;
}
function Ir(e, n) {
  function t() {
    const i = [];
    return De.forEach((o, u) => {
      o === e && i.push(u);
    }), i;
  }
  n(t).forEach((i) => {
    De.set(i, e);
  });
}
var He = function(e, n) {
  return He = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(t, r) {
    t.__proto__ = r;
  } || function(t, r) {
    for (var i in r)
      Object.prototype.hasOwnProperty.call(r, i) && (t[i] = r[i]);
  }, He(e, n);
};
function z(e, n) {
  if (typeof n != "function" && n !== null)
    throw new TypeError("Class extends value " + String(n) + " is not a constructor or null");
  He(e, n);
  function t() {
    this.constructor = e;
  }
  e.prototype = n === null ? Object.create(n) : (t.prototype = n.prototype, new t());
}
var Ee = function() {
  return Ee = Object.assign || function(n) {
    for (var t, r = 1, i = arguments.length; r < i; r++) {
      t = arguments[r];
      for (var o in t)
        Object.prototype.hasOwnProperty.call(t, o) && (n[o] = t[o]);
    }
    return n;
  }, Ee.apply(this, arguments);
};
function an(e, n) {
  var t = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && n.indexOf(r) < 0 && (t[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(e); i < r.length; i++)
      n.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[i]) && (t[r[i]] = e[r[i]]);
  return t;
}
function cn(e, n, t, r) {
  function i(o) {
    return o instanceof t ? o : new t(function(u) {
      u(o);
    });
  }
  return new (t || (t = Promise))(function(o, u) {
    function c(h) {
      try {
        l(r.next(h));
      } catch (v) {
        u(v);
      }
    }
    function a(h) {
      try {
        l(r.throw(h));
      } catch (v) {
        u(v);
      }
    }
    function l(h) {
      h.done ? o(h.value) : i(h.value).then(c, a);
    }
    l((r = r.apply(e, n || [])).next());
  });
}
function ht(e, n) {
  var t = { label: 0, sent: function() {
    if (o[0] & 1)
      throw o[1];
    return o[1];
  }, trys: [], ops: [] }, r, i, o, u;
  return u = { next: c(0), throw: c(1), return: c(2) }, typeof Symbol == "function" && (u[Symbol.iterator] = function() {
    return this;
  }), u;
  function c(l) {
    return function(h) {
      return a([l, h]);
    };
  }
  function a(l) {
    if (r)
      throw new TypeError("Generator is already executing.");
    for (; u && (u = 0, l[0] && (t = 0)), t; )
      try {
        if (r = 1, i && (o = l[0] & 2 ? i.return : l[0] ? i.throw || ((o = i.return) && o.call(i), 0) : i.next) && !(o = o.call(i, l[1])).done)
          return o;
        switch (i = 0, o && (l = [l[0] & 2, o.value]), l[0]) {
          case 0:
          case 1:
            o = l;
            break;
          case 4:
            return t.label++, { value: l[1], done: !1 };
          case 5:
            t.label++, i = l[1], l = [0];
            continue;
          case 7:
            l = t.ops.pop(), t.trys.pop();
            continue;
          default:
            if (o = t.trys, !(o = o.length > 0 && o[o.length - 1]) && (l[0] === 6 || l[0] === 2)) {
              t = 0;
              continue;
            }
            if (l[0] === 3 && (!o || l[1] > o[0] && l[1] < o[3])) {
              t.label = l[1];
              break;
            }
            if (l[0] === 6 && t.label < o[1]) {
              t.label = o[1], o = l;
              break;
            }
            if (o && t.label < o[2]) {
              t.label = o[2], t.ops.push(l);
              break;
            }
            o[2] && t.ops.pop(), t.trys.pop();
            continue;
        }
        l = n.call(e, t);
      } catch (h) {
        l = [6, h], i = 0;
      } finally {
        r = o = 0;
      }
    if (l[0] & 5)
      throw l[1];
    return { value: l[0] ? l[1] : void 0, done: !0 };
  }
}
function ae(e) {
  var n = typeof Symbol == "function" && Symbol.iterator, t = n && e[n], r = 0;
  if (t)
    return t.call(e);
  if (e && typeof e.length == "number")
    return {
      next: function() {
        return e && r >= e.length && (e = void 0), { value: e && e[r++], done: !e };
      }
    };
  throw new TypeError(n ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function ee(e, n) {
  var t = typeof Symbol == "function" && e[Symbol.iterator];
  if (!t)
    return e;
  var r = t.call(e), i, o = [], u;
  try {
    for (; (n === void 0 || n-- > 0) && !(i = r.next()).done; )
      o.push(i.value);
  } catch (c) {
    u = { error: c };
  } finally {
    try {
      i && !i.done && (t = r.return) && t.call(r);
    } finally {
      if (u)
        throw u.error;
    }
  }
  return o;
}
function te(e, n, t) {
  if (t || arguments.length === 2)
    for (var r = 0, i = n.length, o; r < i; r++)
      (o || !(r in n)) && (o || (o = Array.prototype.slice.call(n, 0, r)), o[r] = n[r]);
  return e.concat(o || Array.prototype.slice.call(n));
}
function ue(e) {
  return this instanceof ue ? (this.v = e, this) : new ue(e);
}
function ln(e, n, t) {
  if (!Symbol.asyncIterator)
    throw new TypeError("Symbol.asyncIterator is not defined.");
  var r = t.apply(e, n || []), i, o = [];
  return i = {}, u("next"), u("throw"), u("return"), i[Symbol.asyncIterator] = function() {
    return this;
  }, i;
  function u(s) {
    r[s] && (i[s] = function(m) {
      return new Promise(function(w, g) {
        o.push([s, m, w, g]) > 1 || c(s, m);
      });
    });
  }
  function c(s, m) {
    try {
      a(r[s](m));
    } catch (w) {
      v(o[0][3], w);
    }
  }
  function a(s) {
    s.value instanceof ue ? Promise.resolve(s.value.v).then(l, h) : v(o[0][2], s);
  }
  function l(s) {
    c("next", s);
  }
  function h(s) {
    c("throw", s);
  }
  function v(s, m) {
    s(m), o.shift(), o.length && c(o[0][0], o[0][1]);
  }
}
function sn(e) {
  if (!Symbol.asyncIterator)
    throw new TypeError("Symbol.asyncIterator is not defined.");
  var n = e[Symbol.asyncIterator], t;
  return n ? n.call(e) : (e = typeof ae == "function" ? ae(e) : e[Symbol.iterator](), t = {}, r("next"), r("throw"), r("return"), t[Symbol.asyncIterator] = function() {
    return this;
  }, t);
  function r(o) {
    t[o] = e[o] && function(u) {
      return new Promise(function(c, a) {
        u = e[o](u), i(c, a, u.done, u.value);
      });
    };
  }
  function i(o, u, c, a) {
    Promise.resolve(a).then(function(l) {
      o({ value: l, done: c });
    }, u);
  }
}
function O(e) {
  return typeof e == "function";
}
function qe(e) {
  var n = function(r) {
    Error.call(r), r.stack = new Error().stack;
  }, t = e(n);
  return t.prototype = Object.create(Error.prototype), t.prototype.constructor = t, t;
}
var Ue = qe(function(e) {
  return function(t) {
    e(this), this.message = t ? t.length + ` errors occurred during unsubscription:
` + t.map(function(r, i) {
      return i + 1 + ") " + r.toString();
    }).join(`
  `) : "", this.name = "UnsubscriptionError", this.errors = t;
  };
});
function Te(e, n) {
  if (e) {
    var t = e.indexOf(n);
    0 <= t && e.splice(t, 1);
  }
}
var ye = function() {
  function e(n) {
    this.initialTeardown = n, this.closed = !1, this._parentage = null, this._finalizers = null;
  }
  return e.prototype.unsubscribe = function() {
    var n, t, r, i, o;
    if (!this.closed) {
      this.closed = !0;
      var u = this._parentage;
      if (u)
        if (this._parentage = null, Array.isArray(u))
          try {
            for (var c = ae(u), a = c.next(); !a.done; a = c.next()) {
              var l = a.value;
              l.remove(this);
            }
          } catch (g) {
            n = { error: g };
          } finally {
            try {
              a && !a.done && (t = c.return) && t.call(c);
            } finally {
              if (n)
                throw n.error;
            }
          }
        else
          u.remove(this);
      var h = this.initialTeardown;
      if (O(h))
        try {
          h();
        } catch (g) {
          o = g instanceof Ue ? g.errors : [g];
        }
      var v = this._finalizers;
      if (v) {
        this._finalizers = null;
        try {
          for (var s = ae(v), m = s.next(); !m.done; m = s.next()) {
            var w = m.value;
            try {
              et(w);
            } catch (g) {
              o = o ?? [], g instanceof Ue ? o = te(te([], ee(o)), ee(g.errors)) : o.push(g);
            }
          }
        } catch (g) {
          r = { error: g };
        } finally {
          try {
            m && !m.done && (i = s.return) && i.call(s);
          } finally {
            if (r)
              throw r.error;
          }
        }
      }
      if (o)
        throw new Ue(o);
    }
  }, e.prototype.add = function(n) {
    var t;
    if (n && n !== this)
      if (this.closed)
        et(n);
      else {
        if (n instanceof e) {
          if (n.closed || n._hasParent(this))
            return;
          n._addParent(this);
        }
        (this._finalizers = (t = this._finalizers) !== null && t !== void 0 ? t : []).push(n);
      }
  }, e.prototype._hasParent = function(n) {
    var t = this._parentage;
    return t === n || Array.isArray(t) && t.includes(n);
  }, e.prototype._addParent = function(n) {
    var t = this._parentage;
    this._parentage = Array.isArray(t) ? (t.push(n), t) : t ? [t, n] : n;
  }, e.prototype._removeParent = function(n) {
    var t = this._parentage;
    t === n ? this._parentage = null : Array.isArray(t) && Te(t, n);
  }, e.prototype.remove = function(n) {
    var t = this._finalizers;
    t && Te(t, n), n instanceof e && n._removeParent(this);
  }, e.EMPTY = function() {
    var n = new e();
    return n.closed = !0, n;
  }(), e;
}(), vt = ye.EMPTY;
function pt(e) {
  return e instanceof ye || e && "closed" in e && O(e.remove) && O(e.add) && O(e.unsubscribe);
}
function et(e) {
  O(e) ? e() : e.unsubscribe();
}
var yt = {
  onUnhandledError: null,
  onStoppedNotification: null,
  Promise: void 0,
  useDeprecatedSynchronousErrorHandling: !1,
  useDeprecatedNextContext: !1
}, Ye = {
  setTimeout: function(e, n) {
    for (var t = [], r = 2; r < arguments.length; r++)
      t[r - 2] = arguments[r];
    var i = Ye.delegate;
    return i != null && i.setTimeout ? i.setTimeout.apply(i, te([e, n], ee(t))) : setTimeout.apply(void 0, te([e, n], ee(t)));
  },
  clearTimeout: function(e) {
    var n = Ye.delegate;
    return ((n == null ? void 0 : n.clearTimeout) || clearTimeout)(e);
  },
  delegate: void 0
};
function bt(e) {
  Ye.setTimeout(function() {
    throw e;
  });
}
function Ke() {
}
function Ie(e) {
  e();
}
var Ve = function(e) {
  z(n, e);
  function n(t) {
    var r = e.call(this) || this;
    return r.isStopped = !1, t ? (r.destination = t, pt(t) && t.add(r)) : r.destination = vn, r;
  }
  return n.create = function(t, r, i) {
    return new he(t, r, i);
  }, n.prototype.next = function(t) {
    this.isStopped || this._next(t);
  }, n.prototype.error = function(t) {
    this.isStopped || (this.isStopped = !0, this._error(t));
  }, n.prototype.complete = function() {
    this.isStopped || (this.isStopped = !0, this._complete());
  }, n.prototype.unsubscribe = function() {
    this.closed || (this.isStopped = !0, e.prototype.unsubscribe.call(this), this.destination = null);
  }, n.prototype._next = function(t) {
    this.destination.next(t);
  }, n.prototype._error = function(t) {
    try {
      this.destination.error(t);
    } finally {
      this.unsubscribe();
    }
  }, n.prototype._complete = function() {
    try {
      this.destination.complete();
    } finally {
      this.unsubscribe();
    }
  }, n;
}(ye), fn = Function.prototype.bind;
function Me(e, n) {
  return fn.call(e, n);
}
var dn = function() {
  function e(n) {
    this.partialObserver = n;
  }
  return e.prototype.next = function(n) {
    var t = this.partialObserver;
    if (t.next)
      try {
        t.next(n);
      } catch (r) {
        Se(r);
      }
  }, e.prototype.error = function(n) {
    var t = this.partialObserver;
    if (t.error)
      try {
        t.error(n);
      } catch (r) {
        Se(r);
      }
    else
      Se(n);
  }, e.prototype.complete = function() {
    var n = this.partialObserver;
    if (n.complete)
      try {
        n.complete();
      } catch (t) {
        Se(t);
      }
  }, e;
}(), he = function(e) {
  z(n, e);
  function n(t, r, i) {
    var o = e.call(this) || this, u;
    if (O(t) || !t)
      u = {
        next: t ?? void 0,
        error: r ?? void 0,
        complete: i ?? void 0
      };
    else {
      var c;
      o && yt.useDeprecatedNextContext ? (c = Object.create(t), c.unsubscribe = function() {
        return o.unsubscribe();
      }, u = {
        next: t.next && Me(t.next, c),
        error: t.error && Me(t.error, c),
        complete: t.complete && Me(t.complete, c)
      }) : u = t;
    }
    return o.destination = new dn(u), o;
  }
  return n;
}(Ve);
function Se(e) {
  bt(e);
}
function hn(e) {
  throw e;
}
var vn = {
  closed: !0,
  next: Ke,
  error: hn,
  complete: Ke
};
function M(e, n, t, r, i) {
  return new pn(e, n, t, r, i);
}
var pn = function(e) {
  z(n, e);
  function n(t, r, i, o, u, c) {
    var a = e.call(this, t) || this;
    return a.onFinalize = u, a.shouldUnsubscribe = c, a._next = r ? function(l) {
      try {
        r(l);
      } catch (h) {
        t.error(h);
      }
    } : e.prototype._next, a._error = o ? function(l) {
      try {
        o(l);
      } catch (h) {
        t.error(h);
      } finally {
        this.unsubscribe();
      }
    } : e.prototype._error, a._complete = i ? function() {
      try {
        i();
      } catch (l) {
        t.error(l);
      } finally {
        this.unsubscribe();
      }
    } : e.prototype._complete, a;
  }
  return n.prototype.unsubscribe = function() {
    var t;
    if (!this.shouldUnsubscribe || this.shouldUnsubscribe()) {
      var r = this.closed;
      e.prototype.unsubscribe.call(this), !r && ((t = this.onFinalize) === null || t === void 0 || t.call(this));
    }
  }, n;
}(Ve), Ge = function() {
  return typeof Symbol == "function" && Symbol.observable || "@@observable";
}();
function $e(e) {
  return e;
}
function yn(e) {
  return e.length === 0 ? $e : e.length === 1 ? e[0] : function(t) {
    return e.reduce(function(r, i) {
      return i(r);
    }, t);
  };
}
var A = function() {
  function e(n) {
    n && (this._subscribe = n);
  }
  return e.prototype.lift = function(n) {
    var t = new e();
    return t.source = this, t.operator = n, t;
  }, e.prototype.subscribe = function(n, t, r) {
    var i = this, o = mn(n) ? n : new he(n, t, r);
    return Ie(function() {
      var u = i, c = u.operator, a = u.source;
      o.add(c ? c.call(o, a) : a ? i._subscribe(o) : i._trySubscribe(o));
    }), o;
  }, e.prototype._trySubscribe = function(n) {
    try {
      return this._subscribe(n);
    } catch (t) {
      n.error(t);
    }
  }, e.prototype.forEach = function(n, t) {
    var r = this;
    return t = tt(t), new t(function(i, o) {
      var u = new he({
        next: function(c) {
          try {
            n(c);
          } catch (a) {
            o(a), u.unsubscribe();
          }
        },
        error: o,
        complete: i
      });
      r.subscribe(u);
    });
  }, e.prototype._subscribe = function(n) {
    var t;
    return (t = this.source) === null || t === void 0 ? void 0 : t.subscribe(n);
  }, e.prototype[Ge] = function() {
    return this;
  }, e.prototype.pipe = function() {
    for (var n = [], t = 0; t < arguments.length; t++)
      n[t] = arguments[t];
    return yn(n)(this);
  }, e.prototype.toPromise = function(n) {
    var t = this;
    return n = tt(n), new n(function(r, i) {
      var o;
      t.subscribe(function(u) {
        return o = u;
      }, function(u) {
        return i(u);
      }, function() {
        return r(o);
      });
    });
  }, e.create = function(n) {
    return new e(n);
  }, e;
}();
function tt(e) {
  var n;
  return (n = e ?? yt.Promise) !== null && n !== void 0 ? n : Promise;
}
function bn(e) {
  return e && O(e.next) && O(e.error) && O(e.complete);
}
function mn(e) {
  return e && e instanceof Ve || bn(e) && pt(e);
}
var mt = function(e) {
  return e && typeof e.length == "number" && typeof e != "function";
};
function _t(e) {
  return O(e == null ? void 0 : e.then);
}
function gt(e) {
  return O(e[Ge]);
}
function wt(e) {
  return Symbol.asyncIterator && O(e == null ? void 0 : e[Symbol.asyncIterator]);
}
function St(e) {
  return new TypeError("You provided " + (e !== null && typeof e == "object" ? "an invalid object" : "'" + e + "'") + " where a stream was expected. You can provide an Observable, Promise, ReadableStream, Array, AsyncIterable, or Iterable.");
}
function _n() {
  return typeof Symbol != "function" || !Symbol.iterator ? "@@iterator" : Symbol.iterator;
}
var It = _n();
function Et(e) {
  return O(e == null ? void 0 : e[It]);
}
function Tt(e) {
  return ln(this, arguments, function() {
    var t, r, i, o;
    return ht(this, function(u) {
      switch (u.label) {
        case 0:
          t = e.getReader(), u.label = 1;
        case 1:
          u.trys.push([1, , 9, 10]), u.label = 2;
        case 2:
          return [4, ue(t.read())];
        case 3:
          return r = u.sent(), i = r.value, o = r.done, o ? [4, ue(void 0)] : [3, 5];
        case 4:
          return [2, u.sent()];
        case 5:
          return [4, ue(i)];
        case 6:
          return [4, u.sent()];
        case 7:
          return u.sent(), [3, 2];
        case 8:
          return [3, 10];
        case 9:
          return t.releaseLock(), [7];
        case 10:
          return [2];
      }
    });
  });
}
function Ot(e) {
  return O(e == null ? void 0 : e.getReader);
}
function j(e) {
  if (e instanceof A)
    return e;
  if (e != null) {
    if (gt(e))
      return gn(e);
    if (mt(e))
      return wn(e);
    if (_t(e))
      return Sn(e);
    if (wt(e))
      return Pt(e);
    if (Et(e))
      return In(e);
    if (Ot(e))
      return En(e);
  }
  throw St(e);
}
function gn(e) {
  return new A(function(n) {
    var t = e[Ge]();
    if (O(t.subscribe))
      return t.subscribe(n);
    throw new TypeError("Provided object does not correctly implement Symbol.observable");
  });
}
function wn(e) {
  return new A(function(n) {
    for (var t = 0; t < e.length && !n.closed; t++)
      n.next(e[t]);
    n.complete();
  });
}
function Sn(e) {
  return new A(function(n) {
    e.then(function(t) {
      n.closed || (n.next(t), n.complete());
    }, function(t) {
      return n.error(t);
    }).then(null, bt);
  });
}
function In(e) {
  return new A(function(n) {
    var t, r;
    try {
      for (var i = ae(e), o = i.next(); !o.done; o = i.next()) {
        var u = o.value;
        if (n.next(u), n.closed)
          return;
      }
    } catch (c) {
      t = { error: c };
    } finally {
      try {
        o && !o.done && (r = i.return) && r.call(i);
      } finally {
        if (t)
          throw t.error;
      }
    }
    n.complete();
  });
}
function Pt(e) {
  return new A(function(n) {
    Tn(e, n).catch(function(t) {
      return n.error(t);
    });
  });
}
function En(e) {
  return Pt(Tt(e));
}
function Tn(e, n) {
  var t, r, i, o;
  return cn(this, void 0, void 0, function() {
    var u, c;
    return ht(this, function(a) {
      switch (a.label) {
        case 0:
          a.trys.push([0, 5, 6, 11]), t = sn(e), a.label = 1;
        case 1:
          return [4, t.next()];
        case 2:
          if (r = a.sent(), !!r.done)
            return [3, 4];
          if (u = r.value, n.next(u), n.closed)
            return [2];
          a.label = 3;
        case 3:
          return [3, 1];
        case 4:
          return [3, 11];
        case 5:
          return c = a.sent(), i = { error: c }, [3, 11];
        case 6:
          return a.trys.push([6, , 9, 10]), r && !r.done && (o = t.return) ? [4, o.call(t)] : [3, 8];
        case 7:
          a.sent(), a.label = 8;
        case 8:
          return [3, 10];
        case 9:
          if (i)
            throw i.error;
          return [7];
        case 10:
          return [7];
        case 11:
          return n.complete(), [2];
      }
    });
  });
}
function On(e, n) {
  n === void 0 && (n = {});
  var t = n.selector, r = an(n, ["selector"]);
  return new A(function(i) {
    var o = new AbortController(), u = o.signal, c = !0, a = r.signal;
    if (a)
      if (a.aborted)
        o.abort();
      else {
        var l = function() {
          u.aborted || o.abort();
        };
        a.addEventListener("abort", l), i.add(function() {
          return a.removeEventListener("abort", l);
        });
      }
    var h = Ee(Ee({}, r), { signal: u }), v = function(s) {
      c = !1, i.error(s);
    };
    return fetch(e, h).then(function(s) {
      t ? j(t(s)).subscribe(M(i, void 0, function() {
        c = !1, i.complete();
      }, v)) : (c = !1, i.next(s), i.complete());
    }).catch(v), function() {
      c && o.abort();
    };
  });
}
function Pn(e) {
  return O(e == null ? void 0 : e.lift);
}
function B(e) {
  return function(n) {
    if (Pn(n))
      return n.lift(function(t) {
        try {
          return e(t, this);
        } catch (r) {
          this.error(r);
        }
      });
    throw new TypeError("Unable to lift unknown Observable type");
  };
}
var kn = qe(function(e) {
  return function() {
    e(this), this.name = "ObjectUnsubscribedError", this.message = "object unsubscribed";
  };
}), Pe = function(e) {
  z(n, e);
  function n() {
    var t = e.call(this) || this;
    return t.closed = !1, t.currentObservers = null, t.observers = [], t.isStopped = !1, t.hasError = !1, t.thrownError = null, t;
  }
  return n.prototype.lift = function(t) {
    var r = new nt(this, this);
    return r.operator = t, r;
  }, n.prototype._throwIfClosed = function() {
    if (this.closed)
      throw new kn();
  }, n.prototype.next = function(t) {
    var r = this;
    Ie(function() {
      var i, o;
      if (r._throwIfClosed(), !r.isStopped) {
        r.currentObservers || (r.currentObservers = Array.from(r.observers));
        try {
          for (var u = ae(r.currentObservers), c = u.next(); !c.done; c = u.next()) {
            var a = c.value;
            a.next(t);
          }
        } catch (l) {
          i = { error: l };
        } finally {
          try {
            c && !c.done && (o = u.return) && o.call(u);
          } finally {
            if (i)
              throw i.error;
          }
        }
      }
    });
  }, n.prototype.error = function(t) {
    var r = this;
    Ie(function() {
      if (r._throwIfClosed(), !r.isStopped) {
        r.hasError = r.isStopped = !0, r.thrownError = t;
        for (var i = r.observers; i.length; )
          i.shift().error(t);
      }
    });
  }, n.prototype.complete = function() {
    var t = this;
    Ie(function() {
      if (t._throwIfClosed(), !t.isStopped) {
        t.isStopped = !0;
        for (var r = t.observers; r.length; )
          r.shift().complete();
      }
    });
  }, n.prototype.unsubscribe = function() {
    this.isStopped = this.closed = !0, this.observers = this.currentObservers = null;
  }, Object.defineProperty(n.prototype, "observed", {
    get: function() {
      var t;
      return ((t = this.observers) === null || t === void 0 ? void 0 : t.length) > 0;
    },
    enumerable: !1,
    configurable: !0
  }), n.prototype._trySubscribe = function(t) {
    return this._throwIfClosed(), e.prototype._trySubscribe.call(this, t);
  }, n.prototype._subscribe = function(t) {
    return this._throwIfClosed(), this._checkFinalizedStatuses(t), this._innerSubscribe(t);
  }, n.prototype._innerSubscribe = function(t) {
    var r = this, i = this, o = i.hasError, u = i.isStopped, c = i.observers;
    return o || u ? vt : (this.currentObservers = null, c.push(t), new ye(function() {
      r.currentObservers = null, Te(c, t);
    }));
  }, n.prototype._checkFinalizedStatuses = function(t) {
    var r = this, i = r.hasError, o = r.thrownError, u = r.isStopped;
    i ? t.error(o) : u && t.complete();
  }, n.prototype.asObservable = function() {
    var t = new A();
    return t.source = this, t;
  }, n.create = function(t, r) {
    return new nt(t, r);
  }, n;
}(A), nt = function(e) {
  z(n, e);
  function n(t, r) {
    var i = e.call(this) || this;
    return i.destination = t, i.source = r, i;
  }
  return n.prototype.next = function(t) {
    var r, i;
    (i = (r = this.destination) === null || r === void 0 ? void 0 : r.next) === null || i === void 0 || i.call(r, t);
  }, n.prototype.error = function(t) {
    var r, i;
    (i = (r = this.destination) === null || r === void 0 ? void 0 : r.error) === null || i === void 0 || i.call(r, t);
  }, n.prototype.complete = function() {
    var t, r;
    (r = (t = this.destination) === null || t === void 0 ? void 0 : t.complete) === null || r === void 0 || r.call(t);
  }, n.prototype._subscribe = function(t) {
    var r, i;
    return (i = (r = this.source) === null || r === void 0 ? void 0 : r.subscribe(t)) !== null && i !== void 0 ? i : vt;
  }, n;
}(Pe), ze = {
  now: function() {
    return (ze.delegate || Date).now();
  },
  delegate: void 0
}, kt = function(e) {
  z(n, e);
  function n(t, r, i) {
    t === void 0 && (t = 1 / 0), r === void 0 && (r = 1 / 0), i === void 0 && (i = ze);
    var o = e.call(this) || this;
    return o._bufferSize = t, o._windowTime = r, o._timestampProvider = i, o._buffer = [], o._infiniteTimeWindow = !0, o._infiniteTimeWindow = r === 1 / 0, o._bufferSize = Math.max(1, t), o._windowTime = Math.max(1, r), o;
  }
  return n.prototype.next = function(t) {
    var r = this, i = r.isStopped, o = r._buffer, u = r._infiniteTimeWindow, c = r._timestampProvider, a = r._windowTime;
    i || (o.push(t), !u && o.push(c.now() + a)), this._trimBuffer(), e.prototype.next.call(this, t);
  }, n.prototype._subscribe = function(t) {
    this._throwIfClosed(), this._trimBuffer();
    for (var r = this._innerSubscribe(t), i = this, o = i._infiniteTimeWindow, u = i._buffer, c = u.slice(), a = 0; a < c.length && !t.closed; a += o ? 1 : 2)
      t.next(c[a]);
    return this._checkFinalizedStatuses(t), r;
  }, n.prototype._trimBuffer = function() {
    var t = this, r = t._bufferSize, i = t._timestampProvider, o = t._buffer, u = t._infiniteTimeWindow, c = (u ? 1 : 2) * r;
    if (r < 1 / 0 && c < o.length && o.splice(0, o.length - c), !u) {
      for (var a = i.now(), l = 0, h = 1; h < o.length && o[h] <= a; h += 2)
        l = h;
      l && o.splice(0, l + 1);
    }
  }, n;
}(Pe), An = function(e) {
  z(n, e);
  function n(t, r) {
    return e.call(this) || this;
  }
  return n.prototype.schedule = function(t, r) {
    return this;
  }, n;
}(ye), Oe = {
  setInterval: function(e, n) {
    for (var t = [], r = 2; r < arguments.length; r++)
      t[r - 2] = arguments[r];
    var i = Oe.delegate;
    return i != null && i.setInterval ? i.setInterval.apply(i, te([e, n], ee(t))) : setInterval.apply(void 0, te([e, n], ee(t)));
  },
  clearInterval: function(e) {
    var n = Oe.delegate;
    return ((n == null ? void 0 : n.clearInterval) || clearInterval)(e);
  },
  delegate: void 0
}, xn = function(e) {
  z(n, e);
  function n(t, r) {
    var i = e.call(this, t, r) || this;
    return i.scheduler = t, i.work = r, i.pending = !1, i;
  }
  return n.prototype.schedule = function(t, r) {
    var i;
    if (r === void 0 && (r = 0), this.closed)
      return this;
    this.state = t;
    var o = this.id, u = this.scheduler;
    return o != null && (this.id = this.recycleAsyncId(u, o, r)), this.pending = !0, this.delay = r, this.id = (i = this.id) !== null && i !== void 0 ? i : this.requestAsyncId(u, this.id, r), this;
  }, n.prototype.requestAsyncId = function(t, r, i) {
    return i === void 0 && (i = 0), Oe.setInterval(t.flush.bind(t, this), i);
  }, n.prototype.recycleAsyncId = function(t, r, i) {
    if (i === void 0 && (i = 0), i != null && this.delay === i && this.pending === !1)
      return r;
    r != null && Oe.clearInterval(r);
  }, n.prototype.execute = function(t, r) {
    if (this.closed)
      return new Error("executing a cancelled action");
    this.pending = !1;
    var i = this._execute(t, r);
    if (i)
      return i;
    this.pending === !1 && this.id != null && (this.id = this.recycleAsyncId(this.scheduler, this.id, null));
  }, n.prototype._execute = function(t, r) {
    var i = !1, o;
    try {
      this.work(t);
    } catch (u) {
      i = !0, o = u || new Error("Scheduled action threw falsy error");
    }
    if (i)
      return this.unsubscribe(), o;
  }, n.prototype.unsubscribe = function() {
    if (!this.closed) {
      var t = this, r = t.id, i = t.scheduler, o = i.actions;
      this.work = this.state = this.scheduler = null, this.pending = !1, Te(o, this), r != null && (this.id = this.recycleAsyncId(i, r, null)), this.delay = null, e.prototype.unsubscribe.call(this);
    }
  }, n;
}(An), rt = function() {
  function e(n, t) {
    t === void 0 && (t = e.now), this.schedulerActionCtor = n, this.now = t;
  }
  return e.prototype.schedule = function(n, t, r) {
    return t === void 0 && (t = 0), new this.schedulerActionCtor(this, n).schedule(r, t);
  }, e.now = ze.now, e;
}(), Rn = function(e) {
  z(n, e);
  function n(t, r) {
    r === void 0 && (r = rt.now);
    var i = e.call(this, t, r) || this;
    return i.actions = [], i._active = !1, i;
  }
  return n.prototype.flush = function(t) {
    var r = this.actions;
    if (this._active) {
      r.push(t);
      return;
    }
    var i;
    this._active = !0;
    do
      if (i = t.execute(t.state, t.delay))
        break;
    while (t = r.shift());
    if (this._active = !1, i) {
      for (; t = r.shift(); )
        t.unsubscribe();
      throw i;
    }
  }, n;
}(rt), Ln = new Rn(xn), Cn = Ln, At = new A(function(e) {
  return e.complete();
});
function Un(e) {
  return e ? Mn(e) : At;
}
function Mn(e) {
  return new A(function(n) {
    return e.schedule(function() {
      return n.complete();
    });
  });
}
function Fn(e) {
  return e && O(e.schedule);
}
function X(e, n, t, r, i) {
  r === void 0 && (r = 0), i === void 0 && (i = !1);
  var o = n.schedule(function() {
    t(), i ? e.add(this.schedule(null, r)) : this.unsubscribe();
  }, r);
  if (e.add(o), !i)
    return o;
}
function xt(e, n) {
  return n === void 0 && (n = 0), B(function(t, r) {
    t.subscribe(M(r, function(i) {
      return X(r, e, function() {
        return r.next(i);
      }, n);
    }, function() {
      return X(r, e, function() {
        return r.complete();
      }, n);
    }, function(i) {
      return X(r, e, function() {
        return r.error(i);
      }, n);
    }));
  });
}
function Rt(e, n) {
  return n === void 0 && (n = 0), B(function(t, r) {
    r.add(e.schedule(function() {
      return t.subscribe(r);
    }, n));
  });
}
function jn(e, n) {
  return j(e).pipe(Rt(n), xt(n));
}
function Bn(e, n) {
  return j(e).pipe(Rt(n), xt(n));
}
function Dn(e, n) {
  return new A(function(t) {
    var r = 0;
    return n.schedule(function() {
      r === e.length ? t.complete() : (t.next(e[r++]), t.closed || this.schedule());
    });
  });
}
function Hn(e, n) {
  return new A(function(t) {
    var r;
    return X(t, n, function() {
      r = e[It](), X(t, n, function() {
        var i, o, u;
        try {
          i = r.next(), o = i.value, u = i.done;
        } catch (c) {
          t.error(c);
          return;
        }
        u ? t.complete() : t.next(o);
      }, 0, !0);
    }), function() {
      return O(r == null ? void 0 : r.return) && r.return();
    };
  });
}
function Lt(e, n) {
  if (!e)
    throw new Error("Iterable cannot be null");
  return new A(function(t) {
    X(t, n, function() {
      var r = e[Symbol.asyncIterator]();
      X(t, n, function() {
        r.next().then(function(i) {
          i.done ? t.complete() : t.next(i.value);
        });
      }, 0, !0);
    });
  });
}
function Yn(e, n) {
  return Lt(Tt(e), n);
}
function Kn(e, n) {
  if (e != null) {
    if (gt(e))
      return jn(e, n);
    if (mt(e))
      return Dn(e, n);
    if (_t(e))
      return Bn(e, n);
    if (wt(e))
      return Lt(e, n);
    if (Et(e))
      return Hn(e, n);
    if (Ot(e))
      return Yn(e, n);
  }
  throw St(e);
}
function ve(e, n) {
  return n ? Kn(e, n) : j(e);
}
var Ct = qe(function(e) {
  return function() {
    e(this), this.name = "EmptyError", this.message = "no elements in sequence";
  };
});
function Nn(e) {
  return e instanceof Date && !isNaN(e);
}
function be(e, n) {
  return B(function(t, r) {
    var i = 0;
    t.subscribe(M(r, function(o) {
      r.next(e.call(n, o, i++));
    }));
  });
}
function Wn(e, n, t, r, i, o, u, c) {
  var a = [], l = 0, h = 0, v = !1, s = function() {
    v && !a.length && !l && n.complete();
  }, m = function(g) {
    return l < r ? w(g) : a.push(g);
  }, w = function(g) {
    o && n.next(g), l++;
    var x = !1;
    j(t(g, h++)).subscribe(M(n, function(R) {
      i == null || i(R), o ? m(R) : n.next(R);
    }, function() {
      x = !0;
    }, void 0, function() {
      if (x)
        try {
          l--;
          for (var R = function() {
            var F = a.shift();
            u ? X(n, u, function() {
              return w(F);
            }) : w(F);
          }; a.length && l < r; )
            R();
          s();
        } catch (F) {
          n.error(F);
        }
    }));
  };
  return e.subscribe(M(n, m, function() {
    v = !0, s();
  })), function() {
    c == null || c();
  };
}
function ce(e, n, t) {
  return t === void 0 && (t = 1 / 0), O(n) ? ce(function(r, i) {
    return be(function(o, u) {
      return n(r, o, i, u);
    })(j(e(r, i)));
  }, t) : (typeof n == "number" && (t = n), B(function(r, i) {
    return Wn(r, i, e, t);
  }));
}
function qn(e) {
  return new A(function(n) {
    j(e()).subscribe(n);
  });
}
function Ut(e, n, t) {
  return qn(function() {
    return e() ? n : t;
  });
}
function Vn(e, n, t) {
  e === void 0 && (e = 0), t === void 0 && (t = Cn);
  var r = -1;
  return n != null && (Fn(n) ? t = n : r = n), new A(function(i) {
    var o = Nn(e) ? +e - t.now() : e;
    o < 0 && (o = 0);
    var u = 0;
    return t.schedule(function() {
      i.closed || (i.next(u++), 0 <= r ? this.schedule(void 0, r) : i.complete());
    }, o);
  });
}
function Mt(e, n) {
  return B(function(t, r) {
    var i = 0;
    t.subscribe(M(r, function(o) {
      return e.call(n, o, i++) && r.next(o);
    }));
  });
}
function pe(e) {
  return B(function(n, t) {
    var r = null, i = !1, o;
    r = n.subscribe(M(t, void 0, void 0, function(u) {
      o = j(e(u, pe(e)(n))), r ? (r.unsubscribe(), r = null, o.subscribe(t)) : i = !0;
    })), i && (r.unsubscribe(), r = null, o.subscribe(t));
  });
}
function Gn(e) {
  return B(function(n, t) {
    var r = !1;
    n.subscribe(M(t, function(i) {
      r = !0, t.next(i);
    }, function() {
      r || t.next(e), t.complete();
    }));
  });
}
function $n(e) {
  return e <= 0 ? function() {
    return At;
  } : B(function(n, t) {
    var r = 0;
    n.subscribe(M(t, function(i) {
      ++r <= e && (t.next(i), e <= r && t.complete());
    }));
  });
}
function zn(e) {
  return e === void 0 && (e = Qn), B(function(n, t) {
    var r = !1;
    n.subscribe(M(t, function(i) {
      r = !0, t.next(i);
    }, function() {
      return r ? t.complete() : t.error(e());
    }));
  });
}
function Qn() {
  return new Ct();
}
function Ft(e, n) {
  var t = arguments.length >= 2;
  return function(r) {
    return r.pipe(e ? Mt(function(i, o) {
      return e(i, o, r);
    }) : $e, $n(1), t ? Gn(n) : zn(function() {
      return new Ct();
    }));
  };
}
function jt(e) {
  e === void 0 && (e = 1 / 0);
  var n;
  e && typeof e == "object" ? n = e : n = {
    count: e
  };
  var t = n.count, r = t === void 0 ? 1 / 0 : t, i = n.delay, o = n.resetOnSuccess, u = o === void 0 ? !1 : o;
  return r <= 0 ? $e : B(function(c, a) {
    var l = 0, h, v = function() {
      var s = !1;
      h = c.subscribe(M(a, function(m) {
        u && (l = 0), a.next(m);
      }, void 0, function(m) {
        if (l++ < r) {
          var w = function() {
            h ? (h.unsubscribe(), h = null, v()) : s = !0;
          };
          if (i != null) {
            var g = typeof i == "number" ? Vn(i) : j(i(m, l)), x = M(a, function() {
              x.unsubscribe(), w();
            }, function() {
              a.complete();
            });
            g.subscribe(x);
          } else
            w();
        } else
          a.error(m);
      })), s && (h.unsubscribe(), h = null, v());
    };
    v();
  });
}
function Bt(e) {
  e === void 0 && (e = {});
  var n = e.connector, t = n === void 0 ? function() {
    return new Pe();
  } : n, r = e.resetOnError, i = r === void 0 ? !0 : r, o = e.resetOnComplete, u = o === void 0 ? !0 : o, c = e.resetOnRefCountZero, a = c === void 0 ? !0 : c;
  return function(l) {
    var h, v, s, m = 0, w = !1, g = !1, x = function() {
      v == null || v.unsubscribe(), v = void 0;
    }, R = function() {
      x(), h = s = void 0, w = g = !1;
    }, F = function() {
      var D = h;
      R(), D == null || D.unsubscribe();
    };
    return B(function(D, Q) {
      m++, !g && !w && x();
      var W = s = s ?? t();
      Q.add(function() {
        m--, m === 0 && !g && !w && (v = Fe(F, a));
      }), W.subscribe(Q), !h && m > 0 && (h = new he({
        next: function(H) {
          return W.next(H);
        },
        error: function(H) {
          g = !0, x(), v = Fe(R, i, H), W.error(H);
        },
        complete: function() {
          w = !0, x(), v = Fe(R, u), W.complete();
        }
      }), j(D).subscribe(h));
    })(l);
  };
}
function Fe(e, n) {
  for (var t = [], r = 2; r < arguments.length; r++)
    t[r - 2] = arguments[r];
  if (n === !0) {
    e();
    return;
  }
  if (n !== !1) {
    var i = new he({
      next: function() {
        i.unsubscribe(), e();
      }
    });
    return j(n.apply(void 0, te([], ee(t)))).subscribe(i);
  }
}
function Jn(e) {
  return B(function(n, t) {
    j(e).subscribe(M(t, function() {
      return t.complete();
    }, Ke)), !t.closed && n.subscribe(t);
  });
}
var Ne = { exports: {} }, je = {};
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var it;
function Xn() {
  return it || (it = 1, function(e) {
    function n(f, y) {
      var b = f.length;
      f.push(y);
      e:
        for (; 0 < b; ) {
          var S = b - 1 >>> 1, E = f[S];
          if (0 < i(E, y))
            f[S] = y, f[b] = E, b = S;
          else
            break e;
        }
    }
    function t(f) {
      return f.length === 0 ? null : f[0];
    }
    function r(f) {
      if (f.length === 0)
        return null;
      var y = f[0], b = f.pop();
      if (b !== y) {
        f[0] = b;
        e:
          for (var S = 0, E = f.length, J = E >>> 1; S < J; ) {
            var V = 2 * (S + 1) - 1, se = f[V], G = V + 1, ie = f[G];
            if (0 > i(se, b))
              G < E && 0 > i(ie, se) ? (f[S] = ie, f[G] = b, S = G) : (f[S] = se, f[V] = b, S = V);
            else if (G < E && 0 > i(ie, b))
              f[S] = ie, f[G] = b, S = G;
            else
              break e;
          }
      }
      return y;
    }
    function i(f, y) {
      var b = f.sortIndex - y.sortIndex;
      return b !== 0 ? b : f.id - y.id;
    }
    if (typeof performance == "object" && typeof performance.now == "function") {
      var o = performance;
      e.unstable_now = function() {
        return o.now();
      };
    } else {
      var u = Date, c = u.now();
      e.unstable_now = function() {
        return u.now() - c;
      };
    }
    var a = [], l = [], h = 1, v = null, s = 3, m = !1, w = !1, g = !1, x = typeof setTimeout == "function" ? setTimeout : null, R = typeof clearTimeout == "function" ? clearTimeout : null, F = typeof setImmediate < "u" ? setImmediate : null;
    typeof navigator < "u" && navigator.scheduling !== void 0 && navigator.scheduling.isInputPending !== void 0 && navigator.scheduling.isInputPending.bind(navigator.scheduling);
    function D(f) {
      for (var y = t(l); y !== null; ) {
        if (y.callback === null)
          r(l);
        else if (y.startTime <= f)
          r(l), y.sortIndex = y.expirationTime, n(a, y);
        else
          break;
        y = t(l);
      }
    }
    function Q(f) {
      if (g = !1, D(f), !w)
        if (t(a) !== null)
          w = !0, K(W);
        else {
          var y = t(l);
          y !== null && q(Q, y.startTime - f);
        }
    }
    function W(f, y) {
      w = !1, g && (g = !1, R(Z), Z = -1), m = !0;
      var b = s;
      try {
        for (D(y), v = t(a); v !== null && (!(v.expirationTime > y) || f && !Y()); ) {
          var S = v.callback;
          if (typeof S == "function") {
            v.callback = null, s = v.priorityLevel;
            var E = S(v.expirationTime <= y);
            y = e.unstable_now(), typeof E == "function" ? v.callback = E : v === t(a) && r(a), D(y);
          } else
            r(a);
          v = t(a);
        }
        if (v !== null)
          var J = !0;
        else {
          var V = t(l);
          V !== null && q(Q, V.startTime - y), J = !1;
        }
        return J;
      } finally {
        v = null, s = b, m = !1;
      }
    }
    var H = !1, ne = null, Z = -1, me = 5, U = -1;
    function Y() {
      return !(e.unstable_now() - U < me);
    }
    function le() {
      if (ne !== null) {
        var f = e.unstable_now();
        U = f;
        var y = !0;
        try {
          y = ne(!0, f);
        } finally {
          y ? P() : (H = !1, ne = null);
        }
      } else
        H = !1;
    }
    var P;
    if (typeof F == "function")
      P = function() {
        F(le);
      };
    else if (typeof MessageChannel < "u") {
      var T = new MessageChannel(), re = T.port2;
      T.port1.onmessage = le, P = function() {
        re.postMessage(null);
      };
    } else
      P = function() {
        x(le, 0);
      };
    function K(f) {
      ne = f, H || (H = !0, P());
    }
    function q(f, y) {
      Z = x(function() {
        f(e.unstable_now());
      }, y);
    }
    e.unstable_IdlePriority = 5, e.unstable_ImmediatePriority = 1, e.unstable_LowPriority = 4, e.unstable_NormalPriority = 3, e.unstable_Profiling = null, e.unstable_UserBlockingPriority = 2, e.unstable_cancelCallback = function(f) {
      f.callback = null;
    }, e.unstable_continueExecution = function() {
      w || m || (w = !0, K(W));
    }, e.unstable_forceFrameRate = function(f) {
      0 > f || 125 < f ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : me = 0 < f ? Math.floor(1e3 / f) : 5;
    }, e.unstable_getCurrentPriorityLevel = function() {
      return s;
    }, e.unstable_getFirstCallbackNode = function() {
      return t(a);
    }, e.unstable_next = function(f) {
      switch (s) {
        case 1:
        case 2:
        case 3:
          var y = 3;
          break;
        default:
          y = s;
      }
      var b = s;
      s = y;
      try {
        return f();
      } finally {
        s = b;
      }
    }, e.unstable_pauseExecution = function() {
    }, e.unstable_requestPaint = function() {
    }, e.unstable_runWithPriority = function(f, y) {
      switch (f) {
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
          break;
        default:
          f = 3;
      }
      var b = s;
      s = f;
      try {
        return y();
      } finally {
        s = b;
      }
    }, e.unstable_scheduleCallback = function(f, y, b) {
      var S = e.unstable_now();
      switch (typeof b == "object" && b !== null ? (b = b.delay, b = typeof b == "number" && 0 < b ? S + b : S) : b = S, f) {
        case 1:
          var E = -1;
          break;
        case 2:
          E = 250;
          break;
        case 5:
          E = 1073741823;
          break;
        case 4:
          E = 1e4;
          break;
        default:
          E = 5e3;
      }
      return E = b + E, f = { id: h++, callback: y, priorityLevel: f, startTime: b, expirationTime: E, sortIndex: -1 }, b > S ? (f.sortIndex = b, n(l, f), t(a) === null && f === t(l) && (g ? (R(Z), Z = -1) : g = !0, q(Q, b - S))) : (f.sortIndex = E, n(a, f), w || m || (w = !0, K(W))), f;
    }, e.unstable_shouldYield = Y, e.unstable_wrapCallback = function(f) {
      var y = s;
      return function() {
        var b = s;
        s = y;
        try {
          return f.apply(this, arguments);
        } finally {
          s = b;
        }
      };
    };
  }(je)), je;
}
var Be = {};
/**
 * @license React
 * scheduler.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var ot;
function Zn() {
  return ot || (ot = 1, function(e) {
    process.env.NODE_ENV !== "production" && function() {
      typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
      var n = !1, t = !1, r = 5;
      function i(d, p) {
        var _ = d.length;
        d.push(p), c(d, p, _);
      }
      function o(d) {
        return d.length === 0 ? null : d[0];
      }
      function u(d) {
        if (d.length === 0)
          return null;
        var p = d[0], _ = d.pop();
        return _ !== p && (d[0] = _, a(d, _, 0)), p;
      }
      function c(d, p, _) {
        for (var I = _; I > 0; ) {
          var k = I - 1 >>> 1, N = d[k];
          if (l(N, p) > 0)
            d[k] = p, d[I] = N, I = k;
          else
            return;
        }
      }
      function a(d, p, _) {
        for (var I = _, k = d.length, N = k >>> 1; I < N; ) {
          var L = (I + 1) * 2 - 1, oe = d[L], C = L + 1, we = d[C];
          if (l(oe, p) < 0)
            C < k && l(we, oe) < 0 ? (d[I] = we, d[C] = p, I = C) : (d[I] = oe, d[L] = p, I = L);
          else if (C < k && l(we, p) < 0)
            d[I] = we, d[C] = p, I = C;
          else
            return;
        }
      }
      function l(d, p) {
        var _ = d.sortIndex - p.sortIndex;
        return _ !== 0 ? _ : d.id - p.id;
      }
      var h = 1, v = 2, s = 3, m = 4, w = 5;
      function g(d, p) {
      }
      var x = typeof performance == "object" && typeof performance.now == "function";
      if (x) {
        var R = performance;
        e.unstable_now = function() {
          return R.now();
        };
      } else {
        var F = Date, D = F.now();
        e.unstable_now = function() {
          return F.now() - D;
        };
      }
      var Q = 1073741823, W = -1, H = 250, ne = 5e3, Z = 1e4, me = Q, U = [], Y = [], le = 1, P = null, T = s, re = !1, K = !1, q = !1, f = typeof setTimeout == "function" ? setTimeout : null, y = typeof clearTimeout == "function" ? clearTimeout : null, b = typeof setImmediate < "u" ? setImmediate : null;
      typeof navigator < "u" && navigator.scheduling !== void 0 && navigator.scheduling.isInputPending !== void 0 && navigator.scheduling.isInputPending.bind(navigator.scheduling);
      function S(d) {
        for (var p = o(Y); p !== null; ) {
          if (p.callback === null)
            u(Y);
          else if (p.startTime <= d)
            u(Y), p.sortIndex = p.expirationTime, i(U, p);
          else
            return;
          p = o(Y);
        }
      }
      function E(d) {
        if (q = !1, S(d), !K)
          if (o(U) !== null)
            K = !0, Re(J);
          else {
            var p = o(Y);
            p !== null && Le(E, p.startTime - d);
          }
      }
      function J(d, p) {
        K = !1, q && (q = !1, Ze()), re = !0;
        var _ = T;
        try {
          var I;
          if (!t)
            return V(d, p);
        } finally {
          P = null, T = _, re = !1;
        }
      }
      function V(d, p) {
        var _ = p;
        for (S(_), P = o(U); P !== null && !n && !(P.expirationTime > _ && (!d || Je())); ) {
          var I = P.callback;
          if (typeof I == "function") {
            P.callback = null, T = P.priorityLevel;
            var k = P.expirationTime <= _, N = I(k);
            _ = e.unstable_now(), typeof N == "function" ? P.callback = N : P === o(U) && u(U), S(_);
          } else
            u(U);
          P = o(U);
        }
        if (P !== null)
          return !0;
        var L = o(Y);
        return L !== null && Le(E, L.startTime - _), !1;
      }
      function se(d, p) {
        switch (d) {
          case h:
          case v:
          case s:
          case m:
          case w:
            break;
          default:
            d = s;
        }
        var _ = T;
        T = d;
        try {
          return p();
        } finally {
          T = _;
        }
      }
      function G(d) {
        var p;
        switch (T) {
          case h:
          case v:
          case s:
            p = s;
            break;
          default:
            p = T;
            break;
        }
        var _ = T;
        T = p;
        try {
          return d();
        } finally {
          T = _;
        }
      }
      function ie(d) {
        var p = T;
        return function() {
          var _ = T;
          T = p;
          try {
            return d.apply(this, arguments);
          } finally {
            T = _;
          }
        };
      }
      function qt(d, p, _) {
        var I = e.unstable_now(), k;
        if (typeof _ == "object" && _ !== null) {
          var N = _.delay;
          typeof N == "number" && N > 0 ? k = I + N : k = I;
        } else
          k = I;
        var L;
        switch (d) {
          case h:
            L = W;
            break;
          case v:
            L = H;
            break;
          case w:
            L = me;
            break;
          case m:
            L = Z;
            break;
          case s:
          default:
            L = ne;
            break;
        }
        var oe = k + L, C = {
          id: le++,
          callback: p,
          priorityLevel: d,
          startTime: k,
          expirationTime: oe,
          sortIndex: -1
        };
        return k > I ? (C.sortIndex = k, i(Y, C), o(U) === null && C === o(Y) && (q ? Ze() : q = !0, Le(E, k - I))) : (C.sortIndex = oe, i(U, C), !K && !re && (K = !0, Re(J))), C;
      }
      function Vt() {
      }
      function Gt() {
        !K && !re && (K = !0, Re(J));
      }
      function $t() {
        return o(U);
      }
      function zt(d) {
        d.callback = null;
      }
      function Qt() {
        return T;
      }
      var _e = !1, ge = null, ke = -1, Ae = r, Qe = -1;
      function Je() {
        var d = e.unstable_now() - Qe;
        return !(d < Ae);
      }
      function Jt() {
      }
      function Xt(d) {
        if (d < 0 || d > 125) {
          console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported");
          return;
        }
        d > 0 ? Ae = Math.floor(1e3 / d) : Ae = r;
      }
      var xe = function() {
        if (ge !== null) {
          var d = e.unstable_now();
          Qe = d;
          var p = !0, _ = !0;
          try {
            _ = ge(p, d);
          } finally {
            _ ? fe() : (_e = !1, ge = null);
          }
        } else
          _e = !1;
      }, fe;
      if (typeof b == "function")
        fe = function() {
          b(xe);
        };
      else if (typeof MessageChannel < "u") {
        var Xe = new MessageChannel(), Zt = Xe.port2;
        Xe.port1.onmessage = xe, fe = function() {
          Zt.postMessage(null);
        };
      } else
        fe = function() {
          f(xe, 0);
        };
      function Re(d) {
        ge = d, _e || (_e = !0, fe());
      }
      function Le(d, p) {
        ke = f(function() {
          d(e.unstable_now());
        }, p);
      }
      function Ze() {
        y(ke), ke = -1;
      }
      var en = Jt, tn = null;
      e.unstable_IdlePriority = w, e.unstable_ImmediatePriority = h, e.unstable_LowPriority = m, e.unstable_NormalPriority = s, e.unstable_Profiling = tn, e.unstable_UserBlockingPriority = v, e.unstable_cancelCallback = zt, e.unstable_continueExecution = Gt, e.unstable_forceFrameRate = Xt, e.unstable_getCurrentPriorityLevel = Qt, e.unstable_getFirstCallbackNode = $t, e.unstable_next = G, e.unstable_pauseExecution = Vt, e.unstable_requestPaint = en, e.unstable_runWithPriority = se, e.unstable_scheduleCallback = qt, e.unstable_shouldYield = Je, e.unstable_wrapCallback = ie, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
    }();
  }(Be)), Be;
}
process.env.NODE_ENV === "production" ? Ne.exports = Xn() : Ne.exports = Zn();
var ut = Ne.exports;
const er = 2, tr = 1, nr = "", at = Symbol("loaded"), rr = 40, ir = 40, Dt = typeof on.get(window, "URL.createObjectURL") == "function" && typeof document.createElement("canvas").toBlob == "function";
let Ht = typeof window.createImageBitmap == "function";
class or {
  constructor(n = 800) {
    Ce(this, "cachedKeys", []);
    Ce(this, "cachedStorage", {});
    this.maxKeySize = n;
  }
  set(n, t) {
    if (!this.get(n) && (this.cachedKeys.push(n), this.cachedStorage[n] = t, this.cachedKeys.length > this.maxKeySize)) {
      const r = this.cachedKeys.shift();
      this.deleteItem(r);
    }
  }
  get(n) {
    return this.cachedStorage[n];
  }
  deleteItem(n) {
    const t = this.get(n);
    Dt && URL.revokeObjectURL(t), delete this.cachedStorage[n];
  }
  clear() {
    for (let n = 0; n < this.cachedKeys.length; n += 1)
      this.deleteItem(this.cachedKeys[n]);
    this.cachedKeys.length = 0;
  }
}
function ct(e) {
  return 2 * Math.round(+e / 2);
}
function We(e, n = er) {
  return new A((t) => {
    const r = ut.unstable_scheduleCallback(n, () => {
      e((i) => {
        t.next(i), t.complete();
      });
    });
    return () => ut.unstable_cancelCallback(r);
  });
}
const Yt = new Pe(), Kt = new kt(100), Nt = new kt(100), de = new or();
function lt(e) {
  return new A((n) => {
    const t = new Image();
    return t.src = e, t.onload = () => {
      t[at] = !0, n.next(t), n.complete();
    }, t.onerror = (r) => {
      n.error(r);
    }, () => {
      t[at] || (t.onerror = () => null, t.src = nr);
    };
  });
}
function ur(e) {
  return On(e, {
    cache: "force-cache"
  }).pipe(jt(1));
}
function ar(e) {
  const { url: n } = e;
  return Ut(
    () => typeof window.fetch == "function",
    ur(n).pipe(
      ce((t) => ve(t.blob())),
      pe(() => (Ht = !1, lt(n)))
    ),
    lt(n)
  ).pipe(
    be((t) => ({ error: null, buffer: t })),
    pe((t) => ve([{ error: t }]))
  );
}
const cr = Yt.pipe(
  ce(
    (e) => ar(e),
    ({ uuid: e }, { error: n, buffer: t }) => ({
      buffer: t,
      error: n,
      uuid: e
    }),
    ir
  ),
  Bt()
);
function lr(e, n, t, r) {
  let i = n, o = t;
  if (e && e.width && e.height && !e.origin) {
    const u = r || window.devicePixelRatio || 1, c = Math.max(
      n / (e.width * u),
      t / (e.height * u)
    );
    i = ct(n / c), o = ct(t / c);
  }
  return [i, o];
}
function Wt(e, n) {
  const { originSize: t, box: r } = n, i = 0, o = 0, u = {
    x1: t.width * r[0],
    y1: t.height * r[1],
    width: t.width * (r[2] - r[0]),
    height: t.height * (r[3] - r[1]),
    oriWidth: t.width,
    oriHeight: t.height
  }, [c, a] = lr(n.size, u.width, u.height);
  return {
    ...u,
    cvsWidth: c,
    cvsHeight: a,
    targetX: i,
    targetY: o
  };
}
function sr(e, n) {
  const t = (r) => {
    const {
      cvsHeight: i,
      cvsWidth: o,
      x1: u,
      y1: c,
      width: a,
      height: l,
      targetX: h,
      targetY: v
    } = Wt(e, n), { canvas: s } = n;
    s.width = o, s.height = i;
    const m = s.getContext("2d");
    return m.clearRect(0, 0, o, i), m.drawImage(r, u, c, a, l, h, v, o, i), s;
  };
  return e instanceof HTMLImageElement ? We((r) => {
    r(t(e));
  }) : We((r) => {
    const i = new Image();
    i.src = n.url, i.onload = () => {
      r(t(i));
    };
  });
}
function fr(e, n) {
  const {
    cvsHeight: t,
    cvsWidth: r,
    x1: i,
    y1: o,
    width: u,
    height: c
  } = n;
  return ve(
    window.createImageBitmap(e, i, o, u, c, {
      resizeWidth: r,
      resizeHeight: t,
      resizeQuality: "medium"
    })
  );
}
function dr(e, n) {
  const t = Wt(e, n), { canvas: r } = n;
  return ve(Promise.resolve(e)).pipe(
    ce((i) => fr(i, t)),
    be((i) => {
      const {
        cvsHeight: o,
        cvsWidth: u,
        width: c,
        height: a,
        targetX: l,
        targetY: h
      } = t, v = i.width === u && i.height === o;
      if (r.width = u, r.height = o, v) {
        const s = r.getContext("bitmaprenderer");
        if (s && s.transferFromImageBitmap)
          s.transferFromImageBitmap(i);
        else {
          const m = r.getContext("2d");
          m.clearRect(0, 0, r.width, r.height), m.drawImage(i, 0, 0);
        }
      } else {
        console.warn("CreateImageBitmapOption Unsupported!");
        const s = r.getContext("2d");
        s.clearRect(0, 0, r.width, r.height), s.drawImage(i, 0, 0, c, a, l, h, u, o);
      }
      return r;
    })
  );
}
function hr(e, n) {
  return Ut(
    () => Ht && !(e instanceof HTMLImageElement),
    dr(e, n),
    sr(e, n)
  ).pipe(
    jt(6),
    Jn(Nt.pipe(Ft((t) => t === n.uuid))),
    be((t) => ({ error: null, node: t })),
    pe((t) => ve([{ error: t }]))
  );
}
const vr = Kt.pipe(
  ce(
    (e) => hr(e.buffer, e.drawOptions),
    ({ drawOptions: { uuid: e } }, { node: n, error: t }) => ({
      node: n,
      error: t,
      uuid: e
    }),
    rr
  ),
  Bt()
);
function pr(e, n) {
  return Kt.next({ buffer: e, drawOptions: n }), vr.pipe(Ft(({ uuid: t }) => t === n.uuid));
}
let st = 0;
const ft = (e) => (e(), Un());
function yr(e, n, t) {
  const r = typeof n == "function" ? n : () => n, i = We((o) => {
    const u = new Image();
    u.src = e, u.className = "patsnap-biz-patent_image__img patsnap-biz-patent_image__img--offical", u.onerror = (a) => {
      t(a, r());
    };
    const c = () => {
      var l;
      const a = r();
      (l = a == null ? void 0 : a.appendChild) == null || l.call(a, u), t(), o(a);
    };
    if (typeof HTMLImageElement.prototype.decode != "function") {
      c();
      return;
    }
    u.decoding = "async", u.decode().then(c);
  }, tr).subscribe(() => null);
  return function() {
    i.unsubscribe();
  };
}
function Er(e, n, t, r, i, o) {
  const u = typeof n == "function" ? n : () => n, c = JSON.stringify([e, t, r, i]);
  if (de.get(c)) {
    const s = de.get(c);
    return yr(s, u, o);
  }
  const a = document.createElement("canvas");
  a.className = "patsnap-biz-patent_image__image-canvas", st += 1;
  const l = {
    url: e,
    canvas: a,
    originSize: t,
    box: r,
    size: i,
    uuid: st,
    cacheKey: c
  }, v = cr.pipe(Mt(({ uuid: s }) => s === l.uuid)).pipe(
    ce(({ buffer: s }) => pr(s, l)),
    be(() => ft(() => {
      o(), u().appendChild(a), Dt ? a.toBlob((s) => s && de.set(l.cacheKey, URL.createObjectURL(s))) : de.set(l.cacheKey, a.toDataURL());
    })),
    pe((...s) => ft(() => o(...s, a)))
  ).subscribe(() => null);
  return Yt.next({ uuid: l.uuid, url: e }), function() {
    v.unsubscribe(), Nt.next(l.uuid);
  };
}
function Tr() {
  de.clear();
}
export {
  Er as drawImageToCanvas,
  yr as drawImageToHTMLNode,
  Tr as flushAllCache,
  un as getRenderer,
  Sr as getRendererByFieldName,
  _r as imageFormat,
  wr as installRenderer,
  gr as pdfImageFormat,
  Ir as setRenderer
};
